import React from 'react';
import propTypes from 'prop-types';
import ConfirmDialog from 'chameleon/packages/blue-book-player/library/modal/ConfirmDialog';

const HighlightsAndNotesInfoModal = (props) => {
  const { isVisible, onClose } = props;

  if (!isVisible) {
    return null;
  }

  return (
    <ConfirmDialog
      size="big"
      title="Highlights & Notes"
      aria={{
        'aria-live': 'polite',
      }}
      content={{
        btnPrimary: 'Close',
      }}
      onClose={() => onClose(false)}
      onSuccess={() => onClose(false)}
    >
      <div>
        <h4 className="text-4xl font-bold mt-0">
          Highlights & Notes Is Coming Soon
        </h4>
        <p>
          With Highlights & Notes, you’ll be able to highlight question content
          in different colors and underline styles, and add your own notes to
          the areas you’ve highlighted.
        </p>
      </div>
    </ConfirmDialog>
  );
};

HighlightsAndNotesInfoModal.propTypes = {
  isVisible: propTypes.bool,
  onClose: propTypes.func,
};

HighlightsAndNotesInfoModal.defaultProps = {
  isVisible: false,
  onClose: () => {},
};

export default HighlightsAndNotesInfoModal;
